<template>
<div class="main">
	<!-- 海尔经销商防控计划 -->
	<div class="title">{{res.productName}}</div>
	<Steps :current="2" style="margin:20px auto; width:700px;padding-left:116px">
        <Step title="填写投保信息"></Step>
        <Step title="确认保单"></Step>
        <Step title="支付保单"></Step>
    </Steps>
    <div class="order">
    	<div class="order-title">订单信息</div>
    	<Table :columns="columns" border :data="orderData"></Table>
    </div>
    <div class="pay" v-show="res.payUrl">
    	<div class="code">
    		<div id="qrcode"></div>
    		<p>请使用微信扫码支付</p>
    	</div>
    </div>
</div>
</template>
<script>
import QRCode from 'qrcodejs2'
import track from "@/mixin/track";
export default {
	mixins:[track],
	data () {
		return {
			columns:[
				{
                    title: '产品名称',
                    key: 'productName',
                    render:(h, params) =>{
	                    return h('strong', {
	                        style: {
							    fontSize: '16px'
							},
	                    },params.row.productName)
                    }
                },
                {
                    title: '订单号',
                    key: 'orderNo'
                },
                {
                    title: '订单金额',
                    key: 'price',
                    width:150,
                },
                {
                	title: '支付金额',
                    key: 'payPrice',
                    width:200,
                    render:(h, params) =>{
	                    return h('span', {
	                        style: {
							    color: 'red',
							    fontSize: '25px'
							},
	                    },params.row.payPrice)
                    }
                }
			],
			orderData:[],
			res:{},
			clock:undefined,
			flag:true,
		}
	},
	created () {
		this.getPayInfo()
	},
	mounted () {
		// 回溯 开始录制
		this.$nextTick(this.startRecord);
	},
	methods:{
		/*获取支付信息*/
		getPayInfo () {
			this.$post('/insurance2b/insurance/queryPayInfo',res=>{
				this.res = res.data;
				this.orderData.push({
					...res.data,
					price:res.data.premium+'元',
					payPrice:res.data.premium+'元'
				})
				this.getCode();
				this.checkStatus() //检查支付状态
			},{
				orderNo:this.$route.query.orderNo
			})
		},
		getCode () {
			let qrcode = new QRCode('qrcode', {
		        width: 200,
		        height: 200, // 高度
		        text: this.res.payUrl // 二维码内容
		    })
		},
		/*检查支付状态*/
		checkStatus () {
			let that = this;
			this.clock=setInterval(()=>{
				if(that.flag){
					that.flag=false;
					that.$postNo('/insurance2b/insurance/queryPayStatus',async res=>{
						that.flag=true;
						if(res.data.orderStatus==3){
							that.toast("订单非待支付状态","error");
							clearInterval(that.clock);
							that.res.payUrl = "";
							return;
						}
						if(res.data.orderStatus==2){
							clearInterval(that.clock);
							const { orderNo="" } = that.$route.query;
							// 回溯 停止录制
							await this.stopRecord({
								policy_id: orderNo
							});
							if(that.res.productCode=="GZZRGH"){
								window.location.href = `/haier.html#/order/detail/${that.res.policyId}/${res.data.type}?orderNo=${orderNo}`
							}else{
								window.location.href = `/haier.html#/order/detail/${that.res.policyId}/${res.data.type}`
							}
						}
					},{
						orderNo:that.$route.query.orderNo
					})
				}
			},3000)
		}
	}
}
</script>
<style scoped lang="less">
	.main{
		padding: 20px 30px;
	}
	.order-title{
		font-size: 14px;
		margin-bottom: 10px;
	}
	.pay{
		margin-top: 20px;
		display:flex;
		justify-content: center;
		text-align:center;
	}
	.code>p{
		margin-top: 15px;
	}
</style>


// WEBPACK FOOTER //
// src/pages/common/components/pay/index.vue